module.exports = __webpack_public_path__ + "static/media/close-invoice.6f52d2c5.svg";